module.exports = __webpack_public_path__ + "img/metal_y@2x.063ba383.png";